import React, { useEffect, useState } from "react";
import axios from "axios";

const OfferBanner = () => {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const response = await axios.get("https://admin.tulikaarts.in/api/offer");
        if (response.data.status && response.data.offer?.length > 0) {
          setOffer(response.data.offer[0]);
        }
      } catch (error) {
        console.error("Failed to fetch offer:", error);
      }
    };

    fetchOffer();
  }, []);

  return (
    <div
      className="offer-banner d-flex align-items-center justify-content-center text-center text-white"
      style={{
        backgroundImage: offer
          ? `url(https://admin.tulikaarts.in/${offer.offer_image})`
          : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // minHeight: "50vh",
        width: "100%",
        padding: "2rem",
      }}
    >
      {offer ? (
        <div className="bg-dark bg-opacity-50 p-4 rounded w-100">
          <h1 className="h2 h1-sm">{offer.alt_text}</h1>
          {/* <Link to="/shop">
            <button className="btn btn-light mt-3">Buy Now</button>
          </Link> */}
        </div>
      ) : (
        <h2>Loading Offer...</h2>
      )}
    </div>
  );
};

export default OfferBanner;
